var DataBehavior = require('backbone-torso/modules/behaviors/DataBehavior');
var appointmentTypeCollection = require('./appointmentTypeCollection');

/**
 * Data Behavior hooked up to the appointment type cache.
 * NOTE: this uses external ids to uniquely identify appointment types.
 * @class AppointmentTypeDataBehavior
 * @constructor
 */
module.exports = DataBehavior.extend({
  cache: appointmentTypeCollection
});
